export interface Video {
  id: number;
  title: string;
  category: string;
  categoryName: string;
  thumbnail: string;
  duration: string;
  quality: string;
  views: string;
  rating: string;
  year: string;
  description: string;
  tags: string[];
  featured: boolean;
}

export const videos: Video[] = [
  {
    id: 1,
    title: '繁花如梦 第一季全集',
    category: '91-video',
    categoryName: '91视频',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20cinematic%20film%20poster%20style%20image%20of%20a%20Chinese%20period%20drama%2C%20warm%20golden%20lighting%2C%20elegant%20woman%20in%20traditional%20qipao%20standing%20by%20a%20window%2C%20Shanghai%20cityscape%20in%20background%2C%20soft%20bokeh%2C%20movie%20poster%20aesthetic%2C%20nostalgic%20mood%2C%20high%20quality%20cinematic%20photography&width=800&height=450&seq=video-thumb-01&orientation=landscape',
    duration: '45分钟/集',
    quality: '4K超清',
    views: '1280万',
    rating: '9.2',
    year: '2024',
    description: '一部描绘上海滩风云变幻的年代大戏，讲述了几代人在时代洪流中的命运沉浮，演员阵容豪华，制作精良。',
    tags: ['年代剧', '热门', '高分'],
    featured: true,
  },
  {
    id: 2,
    title: '星际迷航：新纪元',
    category: '97-video',
    categoryName: '97视频',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20sci-fi%20movie%20poster%20style%20with%20a%20spaceship%20flying%20through%20a%20colorful%20nebula%2C%20stars%20in%20background%2C%20futuristic%20design%2C%20cinematic%20lighting%2C%20epic%20scale%2C%20professional%20movie%20poster%20aesthetic%2C%20high%20detail&width=800&height=450&seq=video-thumb-02&orientation=landscape',
    duration: '128分钟',
    quality: '1080P高清',
    views: '890万',
    rating: '8.7',
    year: '2024',
    description: '人类探索宇宙深处的壮丽史诗，视觉特效震撼，剧情扣人心弦，年度必看科幻巨制。',
    tags: ['科幻', '大片', '特效'],
    featured: true,
  },
  {
    id: 3,
    title: '山河令之江湖再见',
    category: '51-video',
    categoryName: '51视频',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20Chinese%20martial%20arts%20drama%20poster%2C%20two%20warriors%20in%20traditional%20robes%20standing%20on%20a%20mountain%20cliff%2C%20misty%20landscape%2C%20dramatic%20sky%2C%20warm%20sunset%20lighting%2C%20wuxia%20aesthetic%2C%20cinematic%20photography%2C%20high%20detail&width=800&height=450&seq=video-thumb-03&orientation=landscape',
    duration: '50分钟/集',
    quality: '4K超清',
    views: '1560万',
    rating: '9.5',
    year: '2024',
    description: '年度最受期待武侠巨制，江湖儿女情长，刀光剑影中的侠义与柔情，全明星阵容倾情演绎。',
    tags: ['武侠', '古装', '热门'],
    featured: true,
  },
  {
    id: 4,
    title: '城市之光 第二季',
    category: '92-video',
    categoryName: '92视频',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20modern%20urban%20drama%20poster%20style%2C%20young%20professionals%20walking%20through%20a%20bustling%20city%20street%20at%20night%2C%20neon%20lights%20reflecting%20on%20wet%20pavement%2C%20contemporary%20fashion%2C%20cinematic%20color%20grading%2C%20urban%20aesthetic&width=800&height=450&seq=video-thumb-04&orientation=landscape',
    duration: '42分钟/集',
    quality: '1080P高清',
    views: '720万',
    rating: '8.9',
    year: '2024',
    description: '聚焦都市年轻人职场与情感生活的现实主义力作，真实细腻，引发广泛共鸣。',
    tags: ['都市', '职场', '情感'],
    featured: false,
  },
  {
    id: 5,
    title: '迷雾追踪 终极篇',
    category: '98-video',
    categoryName: '98视频',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20mystery%20thriller%20movie%20poster%2C%20a%20detective%20in%20a%20dark%20rainy%20alley%2C%20holding%20a%20flashlight%2C%20foggy%20atmosphere%2C%20noir%20style%20lighting%2C%20suspenseful%20mood%2C%20cinematic%20photography%2C%20deep%20shadows%2C%20high%20contrast&width=800&height=450&seq=video-thumb-05&orientation=landscape',
    duration: '135分钟',
    quality: '4K超清',
    views: '950万',
    rating: '9.0',
    year: '2024',
    description: '烧脑悬疑推理大片，层层反转，结局出人意料，国产悬疑电影新标杆。',
    tags: ['悬疑', '推理', '烧脑'],
    featured: true,
  },
  {
    id: 6,
    title: '蓝海传说 全36集',
    category: 'xiaolan-video',
    categoryName: '小蓝视频',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20fantasy%20romance%20drama%20poster%2C%20a%20beautiful%20mermaid%20in%20crystal%20clear%20ocean%20water%2C%20sunlight%20streaming%20through%20the%20surface%2C%20ethereal%20underwater%20scene%2C%20magical%20atmosphere%2C%20soft%20pastel%20colors%2C%20dreamy%20cinematic%20photography&width=800&height=450&seq=video-thumb-06&orientation=landscape',
    duration: '48分钟/集',
    quality: '蓝光原画',
    views: '2100万',
    rating: '9.3',
    year: '2024',
    description: '人鱼与人类的奇幻爱情故事，唯美画面如诗如画，年度现象级爆款甜宠剧。',
    tags: ['奇幻', '爱情', '甜宠'],
    featured: true,
  },
  {
    id: 7,
    title: '妖精的尾巴之终极冒险',
    category: 'yaojing-video',
    categoryName: '妖精视频',
    thumbnail: 'https://readdy.ai/api/search-image?query=An%20animated%20fantasy%20adventure%20poster%2C%20colorful%20magical%20creatures%20in%20an%20enchanted%20forest%2C%20sparkling%20magic%20effects%2C%20vibrant%20colors%2C%20anime%20style%20art%2C%20whimsical%20atmosphere%2C%20high%20quality%20illustration&width=800&height=450&seq=video-thumb-07&orientation=landscape',
    duration: '110分钟',
    quality: '1080P高清',
    views: '680万',
    rating: '8.8',
    year: '2024',
    description: '热门动漫IP全新剧场版，魔法世界的终极对决，视觉盛宴不容错过。',
    tags: ['动漫', '奇幻', '冒险'],
    featured: false,
  },
  {
    id: 8,
    title: '岁月如歌 完整版',
    category: '91-video',
    categoryName: '91视频',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20nostalgic%20family%20drama%20poster%2C%20an%20elderly%20Chinese%20couple%20sitting%20on%20a%20wooden%20bench%20in%20a%20traditional%20courtyard%2C%20warm%20autumn%20leaves%2C%20golden%20hour%20lighting%2C%20sentimental%20mood%2C%20cinematic%20photography%2C%20high%20detail&width=800&height=450&seq=video-thumb-08&orientation=landscape',
    duration: '42分钟/集',
    quality: '4K超清',
    views: '560万',
    rating: '9.4',
    year: '2024',
    description: '温情家庭剧，讲述一家三代人的笑与泪，平凡生活中的不平凡故事，催泪治愈。',
    tags: ['家庭', '温情', '治愈'],
    featured: false,
  },
  {
    id: 9,
    title: '极限追捕 动作大片',
    category: '97-video',
    categoryName: '97视频',
    thumbnail: 'https://readdy.ai/api/search-image?query=An%20action%20thriller%20movie%20poster%2C%20a%20police%20officer%20running%20through%20a%20crowded%20market%2C%20explosions%20in%20background%2C%20dynamic%20action%20pose%2C%20intense%20lighting%2C%20Hollywood%20blockbuster%20style%2C%20high%20adrenaline%2C%20cinematic%20photography&width=800&height=450&seq=video-thumb-09&orientation=landscape',
    duration: '118分钟',
    quality: '1080P高清',
    views: '1320万',
    rating: '8.5',
    year: '2024',
    description: '硬核动作片，全程高能无尿点，拳拳到肉的精彩打斗场面，肾上腺素飙升。',
    tags: ['动作', '警匪', '刺激'],
    featured: true,
  },
  {
    id: 10,
    title: '青春不散场',
    category: '51-video',
    categoryName: '51视频',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20youth%20campus%20drama%20poster%2C%20group%20of%20young%20students%20laughing%20together%20on%20a%20sunny%20school%20playground%2C%20cherry%20blossom%20trees%2C%20bright%20natural%20light%2C%20fresh%20and%20energetic%20vibe%2C%20coming-of-age%20aesthetic%2C%20cinematic%20photography&width=800&height=450&seq=video-thumb-10&orientation=landscape',
    duration: '40分钟/集',
    quality: '4K超清',
    views: '890万',
    rating: '8.6',
    year: '2024',
    description: '青春校园甜宠剧，学霸与校草的甜蜜碰撞，轻松幽默又治愈的校园日常。',
    tags: ['校园', '青春', '甜宠'],
    featured: false,
  },
  {
    id: 11,
    title: '古墓谜踪 系列电影',
    category: '92-video',
    categoryName: '92视频',
    thumbnail: 'https://readdy.ai/api/search-image?query=An%20adventure%20movie%20poster%2C%20explorers%20inside%20an%20ancient%20Chinese%20tomb%2C%20torchlight%20illuminating%20ancient%20artifacts%2C%20mysterious%20atmosphere%2C%20golden%20treasures%2C%20Indiana%20Jones%20style%20adventure%2C%20cinematic%20lighting%2C%20high%20detail&width=800&height=450&seq=video-thumb-11&orientation=landscape',
    duration: '125分钟',
    quality: '1080P高清',
    views: '760万',
    rating: '8.4',
    year: '2024',
    description: '冒险探墓题材电影，紧张刺激的寻宝之旅，古墓中的惊险奇遇。',
    tags: ['冒险', '探墓', '刺激'],
    featured: false,
  },
  {
    id: 12,
    title: '美食人生 纪录片',
    category: '98-video',
    categoryName: '98视频',
    thumbnail: 'https://readdy.ai/api/search-image?query=A%20food%20documentary%20poster%2C%20a%20beautifully%20plated%20Chinese%20dish%20on%20a%20wooden%20table%2C%20steam%20rising%2C%20warm%20kitchen%20lighting%2C%20fresh%20ingredients%20scattered%20around%2C%20mouth-watering%20food%20photography%2C%20rustic%20aesthetic%2C%20high%20detail&width=800&height=450&seq=video-thumb-12&orientation=landscape',
    duration: '55分钟/集',
    quality: '4K超清',
    views: '450万',
    rating: '9.6',
    year: '2024',
    description: '走遍中国大江南北的美食纪录片，每一帧都让人垂涎欲滴，舌尖上的中国文化。',
    tags: ['美食', '纪录片', '文化'],
    featured: false,
  },
];